export default "__VITE_ASSET__DkN0J9TP__"